import {
    BarChart,
    Bar,
    XAxis,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
  } from "recharts";
  
  const Dispositivos = ({ dispositivos }) => {
    const totalGeral = dispositivos.reduce((acc, cur) => acc + cur.total, 0);
  
    return (
      <div className="bg-white rounded-2xl shadow px-2 py-4">
        <p className="text-sm text-gray-500 text-center mb-2">Dispositivos</p>
        <div className="h-[200px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={dispositivos}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="tipo" tick={{ fontSize: 10 }} />
              <Tooltip formatter={(value) => [`${value} visitas`, "Total"]} />
              <Bar dataKey="total" fill="#EC4899" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  };
  
  export default Dispositivos;
  